module.exports = __webpack_public_path__ + "img/im_wine.03637a43.png";